import ModalDevice from 'views/MerchantProfile/Main/Buttons/ModalDevice'
import ModalIdentification from 'views/MerchantProfile/Main/Buttons/ModalIdentification'
import ModalMembership from 'views/MerchantProfile/Main/Buttons/ModalMembership'
import ModalBankAccounts from 'views/MerchantProfile/Main/Buttons/ModalBankAccounts'
import {
  accessControlSubNavigationWithUserTypes,
  accessControlStatus,
} from 'setups/controller'
import { projectClient } from 'constants/project'
import { UserTypeNames } from 'setups/usertypes'

export const MerchantModalModulesData = [
  {
    module: 'Identification Create',
    label: 'Ident',
    value: '1',
    route: {
      title: 'identifications create',
      path: {
        path: '',
        permissionIds: [],
      },
    },
    Modal: ModalIdentification,
  },
  {
    module: 'Device Create',
    label: 'Devices',
    value: '2',
    route: {
      title: 'devices create',
      path: {
        path: '',
        permissionIds: [],
      },
    },
    Modal: ModalDevice,
  },
  {
    module: 'Membership Create',
    label: 'Membership',
    value: '3',
    route: {
      title: 'membership create',
      path: {
        path: '',
        permissionIds: [],
      },
    },
    Modal: ModalMembership,
  },
  {
    module: 'Bank Accounts Create',
    label: 'Bank Accounts',
    value: '4',
    route: {
      title: 'bank accounts create',
      path: {
        path: '',
        permissionIds: [],
      },
    },
    Modal: ModalBankAccounts,
  },
]

export const MERCHANTMODALNAVIGATION_FN = (
  userType: string,
  navModule: string,
  thorUserStatus: string
) => {
  const checkAccessViaHDAUser = accessControlSubNavigationWithUserTypes({
    projectClient,
    navModules: MerchantModalModulesData,
    navModule: 'merchant',
    userType: userType as UserTypeNames,
    isTempBypass: false,
  })
  return accessControlStatus(checkAccessViaHDAUser, navModule, thorUserStatus)
}
